import { render } from "./ProveedoresAdminView.vue?vue&type=template&id=00be85d4&ts=true"
import script from "./ProveedoresAdminView.vue?vue&type=script&lang=ts"
export * from "./ProveedoresAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__